import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';
import solutionImage from '../images/Solution.png'; 
import portfoliaImage from '../images/Portfolio.png';

import enterpriseImage from '../images/Enterprise.png';
import careImage from  '../images/Care.png';
import tradeImage from '../images/Trade.png'

function Services() {
  return (
    <div className="services-container">
      <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '50px'}}>
        {/* Left Column */}
        {/*------Our Solution------*/}
        <div className="services-text-header">
          <br/><br/>
          <h2>Individual or Well-Tuned <br/> Team of Associates</h2>
        </div>

        <div className="container d-flex align-items-center justify-content-between flex-wrap " style={{ marginTop: '-100px'}}>
        {/* Left Column */}
        <div className="services-text-header">
          <p style={{ marginLeft: '-10px'}}>
          Focus on your clients, and your DigitalAssociates will deliver the services behind the scenes. 
          </p>
        </div>
              
        {/* Right Column */}
        {/*---Solution Image---*/}
        <div className="services-image" style={{ marginTop: '-100px'}}>
          <br/>
          <img src= {solutionImage} alt="Investment Illustration" />
        </div>

        <div className="container d-flex align-items-center justify-content-between flex-wrap">
        {/* Left Column */}
        {/*---CareAssociate Section---*/}
        <div className="services-text-header">
          <div className="feature-card">
          <h3><n style={{fontSize: '1.5rem',color: '#FFA302'}}>Care</n><i>Associate</i></h3>
          <p>Supports the entire client journey both through advisors and as a self-service.</p>
        </div>
        </div>
        {/*---PortfolioAssociate Section---*/}        
        <div className="services-text-header">
        <div className="feature-card">
          <h3><n style={{fontSize: '1.5rem',color: '#FFA302'}}>Portfolio</n><i>Associate</i></h3>
          <p>Facilitate the development of your investment program and execute it.</p>
        </div>
        </div>
        {/*---TradeAssociate Section---*/}
        <div className="services-text-header">
        <div className="feature-card">
          <h3><n style={{fontSize: '1.5rem',color: '#FFA302'}}>Trade</n><i>Associate</i></h3>
          <p>Facilitate defining your execution plans, then execute and clear your trades.</p>
        </div>
        </div>
        {/*---EnterpriseAssociate Section---*/}
        <div className="services-text-header">
        <div className="feature-card">
          <h3><n style={{fontSize: '1.5rem',color: '#FFA302'}}>Enterprise</n><i>Associate</i></h3>
          <p>Monitors and enforces your policies throughout your operation.</p>
        </div>
        </div>
        {/*---Demo  Button---*/}
        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-200px'}}>
          <div className="services-text-header" style={{ textAlign: 'center', margin: '0 auto'}}>
            <div>
              <Link to="/BookDemo" className="btn btn-outline-secondary me-2"
              style={{ backgroundColor: 'transparent', border: '2px solid #BFD42F', color: '#000', borderRadius:'16px'}}>
              Book a Demo
              </Link>
            </div>
          </div>
        </div>
        </div>


        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-250px'}}>    
        {/*------Care Associate------*/}
        {/* Left Column */}
        <div className="services-text-header">
          <h2>Care Associate</h2>
          <p>
          Build stronger relationships at every stage, from prospecting to onboarding and ongoing service. CareAssociate uses a unified client record, automated communications, and seamless customer service at the household goal level to help you stay connected, compliant, and client-focused.
          </p>
        </div>
        {/* Right Column */}
        {/*---Care Image---*/}
        <div className="services-image">
          <br /><br />
          <img src= {careImage} alt="Investment Illustration" />
        </div>  
        </div>
        {/*---Marketing Section---*/}
        <div className="container d-flex align-items-center justify-content-between flex-wrap">
        <div className="services-text-header">
          <h3 style={{textAlign:'center'}}>Marketing and Prospecting</h3>
          <div className="feature-card">
          <p>A continuous path from suspect to prospect to client</p>
          <ul>
            <li>Single Client Record</li>
            <li>Prospect Communications</li>
            <li>Campaign Management</li>
            <li>Proposal Generation</li>
          </ul>
        </div>
        </div>
        {/*---Digital Section---*/}
        <div className="services-text-header">
          <h3 style={{textAlign:'center'}}>Digital Onboarding</h3>
          <div className="feature-card">
          <p>Generation and eSignature of KYC, Risk Profile, IPS, and Account Opening documents</p>
          <ul>
            <li>Capturing KYC</li>
            <li>Custom Documents</li>
            <li>eSignature</li>
            <li>Approvals</li>
            <li>Custodian Integration</li>
          </ul>
        </div>
        </div>
        {/*---Client Section---*/}      
        <div className="services-text-header">
          <h3 style={{textAlign:'center'}}>Client Relationship</h3>
          <div className="feature-card">
          <p>Client households and goals at the center for a Deeply Personalized, Perfectly</p>
          <ul>
            <li>Goal-based household from onboarding to servicing</li>
            <li>Goal Planning and servicing at the individual and household level</li>
            <li>Policy-Based Automated Communication</li>
            <li>Policy-Based Automated Communication and Digital Vault</li>
            <li>Custom Client Portal</li>
          </ul>
        </div>
        </div>
        </div>

        {/*---Demo Button---*/}        
        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-150px'}}>
          <div className="services-text-header" style={{ textAlign: 'center', margin: '0 auto'}}>
            <div>
              <Link to="/BookDemo" className="btn btn-outline-secondary me-2" 
              style={{ backgroundColor: '#fcfcfc', border: '2px solid #BFD42F', color: '#000', borderRadius:'16px'}}>
              Book a Demo
              </Link>
            </div>
          </div>
        </div>

        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-150px'}}>
        {/* Right Column */}
        {/*---Portfolia Image---*/}
        <div className="services-image">
          <br /><br />
          <img src= {portfoliaImage} alt="Investment Illustration" />
        </div>
        {/* Left Colum */}
        {/*------Portfolia Management-------*/}
        <div className="services-text-header">
          <h2>Portfolio Associate</h2>
          <p>
            Maximize returns, minimize risk, and scale confidently as PortfolioAssociate translates client needs into 
            optimized account transactions—powered by cutting-edge model management, personalization, multi-pronged tax 
            optimization, and policy enforcement.
          </p>
        </div>
        {/*---Model Sectiuon---*/}
        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '70px'}}>
        <div className="services-text-header">
          <h3 style={{textAlign:'center'}}>Model Management</h3>
          <div className="feature-card">
          <p>Effortless personalization and tools to get you there</p>
          <ul>
            <li>Sophisticated Asset Support</li>
            <li>Models-of-Models</li>
            <li>Internal and External Models (UMAs and SMAs)</li>
            <li>Mass Customization for Market Segments</li>
            <li>Personalization </li>
            <li>Model Discovery</li>
          </ul>
        </div>
        </div>
        {/*---Portfolia Section---*/}
        <div className="services-text-header">
          <h3 style={{textAlign:'center'}}>Portfolio Management</h3>
          <div className="feature-card">
          <p>Converting clients' needs to transactions for accounts in a tax-optimized manner</p>
          <ul>
            <li>Goal-Level Household Trading</li>
            <li>Rebalancing, Withdrawals, and Deposits</li>
            <li>Asset Location</li>
            <li>Tax Loss Harvesting</li>
            <li>Portfolio Transition</li>
          </ul>
        </div>
        </div>
        {/*---Policy Section---*/}
        <div className="services-text-header">
          <h3 style={{textAlign:'center'}}>Policy Management</h3>
          <div className="feature-card">
          <p>Protecting you and your clients with digital enforcement of policies</p>
          <ul>
            <li>Client Risk Profiling</li>
            <li>Suitability Management</li>
            <li>Assisted Model Discovery</li>
          </ul>
        </div>
        </div>
        </div>
        </div>
        {/*---Demo Button---*/}
        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-150px'}}>
          <div className="services-text-header" style={{ textAlign: 'center', margin: '0 auto'}}>
            <div>
              <Link to="/BookDemo" className="btn btn-outline-secondary me-2"
              style={{ backgroundColor: 'transparent', border: '2px solid #BFD42F', color: '#000', borderRadius:'16px'}}>
              Book a Demo
              </Link>
            </div>
          </div>
        </div>

        {/*------Trading Associate------*/}
        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{marginTop: '-150px'}}>
        <div className="services-text-header">
          <h2>Trading Associate</h2>
          <p>
            Focus on your best execution partners and securities, not thousands of client orders. TradeAssociate automates 
            every aspect of trading from receipt of orders to posting transactions to the Book of Records with continuous 
            order blocking, enrichment and matching using various post-trade networks.
          </p>
        </div>
          {/* Right Column */}
          {/*---Trading Image---*/}
          <div className="services-image">
          <br /><br />
          <img src= {tradeImage} alt="Investment Illustration" />
        </div>
        {/*---Order Section---*/}
        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '100px'}}>
        <div className="services-text-header">
          <h3 style={{textAlign:'center'}}>Order Management</h3>
          <div className="feature-card">
            <p>Focus on securities, not individual orders</p>
          <ul>
            <li>Directly coupled with Portfolio Associate</li>
            <li>Settlement Cash Management</li>
            <li>Trader Segmentation</li>
            <li>Automated Continuous Blocking</li>
            <li>Definable Routing rules</li>
          </ul>
        </div>
        </div>
        {/*---Execution Section---*/}
        <div className="services-text-header">
          <h3 style={{textAlign:'center'}}>Execution Management</h3>
          <div className="feature-card">
            <p>Compliant distribution of executions to clients</p>
          <ul>
            <li>Embedded FIX Engine</li>
            <li>Definable Routing Rules</li>
            <li>Real-time Blotter</li>
            <li>Execution Strategies</li>
            <li>Execution Cost Sensitivity</li>
          </ul>
        </div>
        </div>
        {/*---Post Section---*/}
        <div className="services-text-header">
          <h3 style={{textAlign:'center'}}>Post Trade Support</h3>
          <div className="feature-card">
            <p>Single process, regardless of counterparty or network</p>
          <ul>
            <li>FX Trading </li>
            <li>Generation and Posting of Transactions to the Book of Records</li>
            <li>Matching and Contracting</li>
            <li>Connection to Post-Trade Networks</li>
          </ul>
        </div>
        </div>
        </div>
        </div>
        {/*---Demo Button---*/}
        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-150px'}}>
          <div className="services-text-header" style={{ textAlign: 'center', margin: '0 auto'}}>
            <div>
              <Link to="/BookDemo" className="btn btn-outline-secondary me-2" 
              style={{ backgroundColor: 'transparent', border: '2px solid #BFD42F', color: '#000', borderRadius:'16px'}}>
              Book a Demo
              </Link>
            </div>
          </div>
        </div>

        {/*------Enterprise Supervision------*/}        
        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-200px'}}> 
        {/* Left Column */}
        {/*---Enterprise Image---*/}
        <div className="services-image">
          <br /><br />
          <img src= {enterpriseImage} alt="Investment Illustration" style={{ width:'70%', height: 'auto'}}/>
        </div>
        {/* Right Column */}
        <div className="services-text-header">
          <h2>Enterprise Associate</h2>
          <p>
            Streamline firm-wide operations with powerful tools for product management, compliance enforcement, and 
            executive insights. Use EnterpriseAssociate to define your services, monitor regulatory adherence, and optimize 
            decision-making; stay in control while confidently scaling.
          </p>
        </div>
        {/*---Product Section---*/}
        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '100px'}}>
        <div className="services-text-header">
          <h3 style={{textAlign:'center'}}>Product Management</h3>
          <div className="feature-card">
          <p>Packaging your services and charging models</p>
          <ul>
            <li>Define Multiple Products</li>
            <li>Define Services Delivered by the Firm</li>
            <li>Prerequisites</li>
            <li>Fee and Commission Calculation</li>
          </ul>
        </div>
        </div>
        {/*---Supervisory Section---*/}
        <div className="services-text-header">
          <h3 style={{textAlign:'center'}}>Supervisory and Compliance</h3>
          <div className="feature-card">
          <p>Enforcement, monitoring, and reporting of your compliance</p>
          <ul>
            <li>Supervisory Entitlement</li>
            <li>Functional and Data Access Control</li>
            <li>Policy Control</li>
            <li>Enforcement at all Points of Transaction Initiation</li>
            <li>Non-Compliance Tracking </li>
          </ul>
        </div>
        </div>
        {/*---Operations Section---*/}
        <div className="services-text-header">
          <h3 style={{textAlign:'center'}}>Executive Information</h3>
          <div className="feature-card">
          <p>Business information presented in an actionable format</p>
          <ul>
            <li>Top-Level Executive Information</li>
            <li>Hierarchical Drill Down </li>
            <li>Deep Insight into Firm Activities</li>
          </ul>
        </div>
        </div>
        </div>
        </div>
        {/*---Demo Button---*/}
        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-150px'}}>
          <div className="services-text-header" style={{ textAlign: 'center', margin: '0 auto'}}>
            <div>
              <Link to="/BookDemo" className="btn btn-outline-secondary me-2" 
              style={{ backgroundColor: 'transparent', border: '2px solid #BFD42F', color: '#000', borderRadius:'16px'}}>
              Book a Demo
              </Link>
            </div>
          </div>
        </div>

      </div>
      </div>                    
      {/*------Site Footer------*/}
      <footer className="site-footer" style={{ marginTop: '-100px'}}>
         <div className="container text-center">
            <p>&copy; {new Date().getFullYear()} Cloudvisor DigitalAssociate. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default Services;